import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { FormattedMessage } from 'react-intl';

import { JOURNEY_TRACKER_VISIBLE_ACTIONS } from 'yeself-common/typings/application/ApplicationEnum';

type JourneyTrackerActionValue = typeof JOURNEY_TRACKER_VISIBLE_ACTIONS[keyof typeof JOURNEY_TRACKER_VISIBLE_ACTIONS];

type JourneyDropdownMenuFormProps = {
    onChange: (value: JourneyTrackerActionValue) => void;
    value: JourneyTrackerActionValue;
    classNames: {
        itemTextClassName?: string;
        textField?: string;
        cssSelectRoot?: string;
        cssUnderline?: string;
        menu?: string;
        formInput?: string;
    };
    formattedMessage: {
        id: string;
        defaultMessage: string;
    };
    menuItems: {
        options: JourneyTrackerActionValue;
        id: string;
    };
};

const JourneyDropdownMenuForm = ({
    onChange,
    value,
    classNames = {},
    formattedMessage,
    menuItems,
}: JourneyDropdownMenuFormProps): React.ReactElement => (
    <Grid container alignItems="center" style={{ paddingBottom: '20px' }}>
        <Typography variant="body1" className={classNames.itemTextClassName}>
            <FormattedMessage
                id={formattedMessage.id}
                defaultMessage={formattedMessage.defaultMessage}
            />
        </Typography>
        <Grid item className={classNames.formInput}>
            <TextField
                value={value}
                onChange={(event) => onChange(event.target.value as JourneyTrackerActionValue)}
                select
                fullWidth
                className={classNames.textField}
                margin="normal"
                variant="filled"
                InputProps={{
                    classes: {
                        root: classNames.cssSelectRoot,
                        underline: classNames.cssUnderline,
                    },
                }}
                SelectProps={{
                    MenuProps: {
                        className: classNames.menu,
                    },
                }}
            >
                {Object.values(menuItems.options).map((option) => (
                    <MenuItem id="yeself-menu-item" value={option} key={option}>
                        <FormattedMessage id={`${menuItems.id}.${option}`} />
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    </Grid>
);

export default JourneyDropdownMenuForm;
